module.exports = __webpack_public_path__ + "static/img/cover6.992dfa44.jpg";